import { memo, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ThemedBoltLightningIcon } from "assets/CXFIcons/Designer/Toolbox";
import { ThemedStopIcon, ThemedPlayArrowIcon } from "assets/CXFIcons/Designer/ContextActions";
import { CancelExecutionDialog } from "../../Titlebar/components/TitlebarActions/ExecuteFlowButton/CancelExecutionDialog";
import { useFlexLayout } from "context/AppProvider/FlexLayoutContext";
import { FLEX_LAYOUT_COMPONENT } from "constants/flowDesigner";

const ButtonTriggers = ({
  handleExecute,
  isExecuting,
}) => {
  const { flowTriggers } = useSelector((state) => state?.designer?.triggers);
  const { t } = useTranslation("flowDesigner");
  const [showDialog, setShowDialog] = useState(false);
  const { addLayoutTab } = useFlexLayout();

  const handleAddLayoutTab = (tab) => () => {
    addLayoutTab(
      tab,
      `startNodeProps`,
      `Start Node`,
    );
  };

  const handleStopExecution = () => {
    if (isExecuting) {
      setShowDialog(true);
    }
  }

  const closeDialog = () => {
    setShowDialog(false);
  }

  return (flowTriggers?.length > 0 && (
      <>
        <Tooltip
          title={isExecuting ? t("buttons.cancel_flow_execution") : t("buttons.execute_flow")}
          placement="bottom"
        >
          <IconButton
            className="btn-trigger-menu"
            onClick={isExecuting ? handleStopExecution : handleExecute}
            size="small"
          >
            {isExecuting ? (
              <ThemedStopIcon width="20px" height="20px" />
            ) : (
              <ThemedPlayArrowIcon width="20px" height="20px" hoverColor="#7443FF" />
            )}
          </IconButton>
        </Tooltip>

        <Tooltip title={t("buttons.triggers")} placement="bottom">
          <IconButton className="btn-trigger-menu" onClick={handleAddLayoutTab(FLEX_LAYOUT_COMPONENT.startNode)} size="small">
            <ThemedBoltLightningIcon color="#7443FF" width="20px" height="20px" />
          </IconButton>
        </Tooltip>

        <CancelExecutionDialog showDialog={showDialog} closeDialog={closeDialog} />
      </>
    )
  );
};

export default memo(ButtonTriggers);
